import EventData from '../event/event-data';
import EventListener from '../event/event-listener';

import Mountable from './mountable';

interface FetchEventArgs {
  data?: object;
  error?: Error;
  abort?: Function;
}

class FetchEvent extends EventData<Fetchable> implements FetchEventArgs {

  data?: object;
  error?: Error;
  abort?: Function;

  constructor({ data, error, abort }: FetchEventArgs = {}) {
    super();

    this.data = data;
    this.error = error;
    this.abort = abort;
  }
}

class FetchEventListener extends EventListener<Fetchable, FetchEvent, FetchEventArgs> {
  constructor() {
    super(FetchEvent);
  }
}

export default interface Fetchable extends Mountable {

  /** @event */
  onBeforeFetch: FetchEventListener;

  /** @event */
  onAfterFetch: FetchEventListener;

  /** @event */
  onAbort: FetchEventListener;

}

export { FetchEventListener, FetchEvent };
